import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
    getHelicopterCalendarApi,
    getHelicopterDictTreeApi,
    getHelicopterByDateApi,
    getHelicopterByIdApi,
    getHelicopterActivitiesDataApi,
    postHelicopterCommentApi,
    putHelicopterCommentApi,
    postHelicopterActivitiesDataApi,
} from 'api'
import { BoundarySlice } from 'redux/reducers'

const initialState = {
    calendarInfo: null, // 被点击的日历信息
    calendarData: null, // 日历上当前范围内显示的总结填写信息
    dictData: null, // 数据字典
    listData: null, // 回显数据
    locationName: '', // location 名称
    locationId: '', // location id
    save: false,
    id: '',
}

/* 获取日历上的数据 */
export const getHelicopterCalendarAction = createAsyncThunk(
    'HelicopterSlice/getHelicopterCalendarAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await getHelicopterCalendarApi(params)
            return data.data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 获取数据字典 */
export const getHelicopterDictDataAction = createAsyncThunk(
    'HelicopterSlice/getHelicopterDictDataAction',
    async (dictType, thunkAPI) => {
        const helicopterNameDataDict = getHelicopterDictTreeApi(dictType[0])
        const helicopterActivityDataDict = getHelicopterDictTreeApi(dictType[1])
        return Promise.all([helicopterNameDataDict, helicopterActivityDataDict])
            .then(dictData => dictData)
            .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
    }
)

/* 通过日期获取 id */
export const getHelicopterByDateAction = createAsyncThunk(
    'HelicopterSlice/getHelicopterByDateAction',
    async (listDataParams, thunkAPI) => {
        try {
            const commentData = await getHelicopterByDateApi(listDataParams) // 通过日期查询 id
            return commentData?.data?.data?.id
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 获取数据 */
export const getHelicopterDataAction = createAsyncThunk(
    'HelicopterSlice/getHelicopterDataAction',
    async (id, thunkAPI) => {
        const commentData = getHelicopterByIdApi(id) // 通过 id 查询
        const activitiesData = getHelicopterActivitiesDataApi(id)
        return Promise.all([commentData, activitiesData])
            .then(listData => listData)
            .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
    }
)

/* 保存数据 */
export const postHelicopterDataAction = createAsyncThunk(
    'HelicopterSlice/postHelicopterDataAction',
    async ({ id, commentParams, activitiesParams }, { dispatch }) => {
        let vid
        try {
            if (!id) {
                const commentData = await postHelicopterCommentApi(commentParams) // 新增
                vid = commentData.data.data.id
                await postHelicopterActivitiesDataApi(activitiesParams, vid)
                dispatch(HelicopterSlice.actions.addId(vid))
                return { isTrue: true, id: vid } // 已保存状态
            } else {
                vid = id
                await putHelicopterCommentApi(commentParams, id) // 修改
                await postHelicopterActivitiesDataApi(activitiesParams, id)
                return { isTrue: true, id } // 已保存状态
            }
        } catch (error) {
            dispatch(HelicopterSlice.actions.addId(vid))
            dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

export const HelicopterSlice = createSlice({
    name: 'HelicopterSlice',
    initialState,
    reducers: {
        /* 日历点击信息 */
        addCalendarInfo: (state, action) => {
            state.calendarInfo = action.payload
        },
        /* 清空日历与详情页信息 */
        clearListData: state => {
            state.listData = null
            state.calendarData = null
            state.save = false
            state.id = ''
        },
        /* 当前日历主 id */
        addId: (state, action) => {
            state.id = action.payload
        },
        /* location 名称 */
        addLocationName: (state, action) => {
            state.locationName = action.payload
        },
        /* location id */
        addLocationId: (state, action) => {
            state.locationId = action.payload
        },
    },
    extraReducers: {
        /* 获取日历上的数据 */
        [getHelicopterCalendarAction.fulfilled.type]: (state, action) => {
            state.calendarData = action.payload
        },

        /* 处理数据字典 */
        [getHelicopterDictDataAction.fulfilled.type]: (state, action) => {
            state.dictData = action.payload
        },

        /* 提交总结数据 */
        [postHelicopterDataAction.fulfilled.type]: (state, action) => {
            state.save = action.payload
        },

        /* 获取回显数据 */
        [getHelicopterDataAction.fulfilled.type]: (state, action) => {
            state.listData = action.payload
        },

        /* 通过日期，获取 id */
        [getHelicopterByDateAction.fulfilled.type]: (state, action) => {
            state.id = action.payload
        },
    },
})
